import { getSearchParam } from '@utils/filters';
import axios from '../utils/axios';
import { USER_KEY } from '@utils/constants';
export const getUsers = async (
	page: number = 0,
	size: number = 10,
	filter?: Record<string, string>
) => {
	try {
		const queryParamsFilters: Record<string, string> = {
			page: page?.toString(),
			size: size?.toString(),
			...filter
		};

		const queryParams: string = getSearchParam(queryParamsFilters, USER_KEY);
		const { data } = await axios.get(
			`users/list?${queryParams}`
		);
		return data;
	} catch (error) {
		throw error;
	}
};

export const postUser = async (body: any) => {
	try {
		const res = await axios.post('users', body);
		return res;
	} catch (error) {
		throw error;
	}
};

export const postDoctor = async (body: any) => {
	try {
		const res = await axios.post('doctors', body);
		return res;
	} catch (error) {
		throw error;
	}
};

export const updateUser = async (userId: number, body: any) => {
	try {
		const res = await axios.patch(`users/${userId}`, body);
		return res;
	} catch (error) {
		throw error;
	}
};
